import { AccredibleApiService } from '@accredible-frontend-v2/services/api';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LocationSearch, LocationSearchParams, PlaceDetails } from './location.model';

@Injectable({ providedIn: 'root' })
export class AccredibleLocationApiService extends AccredibleApiService {
  locationSearch(locationSearchParams: LocationSearchParams): Observable<LocationSearch> {
    const searchParams = new URLSearchParams();
    for (const prop in locationSearchParams) {
      if (locationSearchParams.hasOwnProperty(prop)) {
        searchParams.set(prop, locationSearchParams[prop]);
      }
    }

    return this._get(`/v1/accounts/typeahead/location_search?${searchParams.toString()}`).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  getPlaceDetails(placeId: string): Observable<PlaceDetails> {
    return this._get(`/v1/accounts/typeahead/place_details?place_id=${placeId}`).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  getCountryStatePlaceId(country: string, state?: string): Observable<string> {
    const searchParams = new URLSearchParams();
    searchParams.set('name', country + (state ? `/${state}` : ''));
    return this._get(`/v1/recipient/location/place_id?${searchParams.toString()}`).pipe(
      map((res) => this._handleResponse(res, 'place_id')),
      catchError((res) => this._handleError(res)),
    );
  }
}
